<template>
    <Link as="div" :href="route('product.search.searchTerm', [list_item.style_code])" :onStart="()=>emits('navigate')" class="product-list-item">
        <!-- <img class="product-image bg-rothcoCream" :src="imgSrc" :alt="props.list_item.item_name" loading="lazy"> -->
        <div class="product-item">
            <div id="stock_update_title" class="product-item-name title-s">{{ props.list_item.product_line_code }}</div>
            <p id="stock_update_item_no" class="product-item-id">#{{ props.list_item.style_code }}</p>
            <p
            id="stock_update_in_stock"
            class="text-rothcoGreen product-item-upd"
            v-if="props.list_item.status == 1"
        >
            Back in Stock
        </p>
        <p id="stock_update_out_of_stock" class="text-rothcoRed product-item-upd" v-else>
            Out of Stock
        </p>
        <div
                class="product-item-variation"
                v-for="(spec, specIndex) in variantValues"
                :key="specIndex"
            >
                <p>{{ spec }}</p>
            </div>
            <p id="stock_update_updated_at" class="product-item-upd">Updated: {{ useDateFormat(props.list_item.created_at, 'MM/DD/YYYY') }}</p>
        </div>
    </Link>
</template>
<script lang="ts" setup>
    import { computed, inject } from "vue";
    import { Link } from "@inertiajs/vue3";
    import { useDateFormat } from "@vueuse/core";

    let route = inject('route');
    let props = defineProps({
        list_item: {
            type: Object,
            required: true,
            default() {
                return {};
            }
        }
    });

    let emits = defineEmits(['navigate']);

    let variantValues = computed(() => {
        return (
            Object.keys(props.list_item?.web_variation?.description ?? [])?.map(
                (group) => {
                    return `${group}: ${props.list_item?.web_variation?.description[group]}`;
                }
            ) ?? []
        );
    });
</script>
